import { AxiosRequestConfig } from 'axios';
import api from '.';

/**
 * Базовый класс репозиториев.
 *
 * Интерцептор ответа в `@/api` возвращает `response.data.data`, поэтому все
 * методы резолвятся сразу в полезную нагрузку `T`, а не в `AxiosResponse<T>`.
 */
abstract class ApiService {
  protected constructor(resource: string) {
    this.resource = '/api' + resource;
  }

  resource: string;

  async post<T>(url: string, payload: unknown = {}): Promise<T> {
    return await api.post(this.resource + url, payload);
  }

  async get<T>(url: string, config: AxiosRequestConfig = {}): Promise<T> {
    return await api.get(this.resource + url, config);
  }

  async put<T>(url: string, payload: unknown = {}): Promise<T> {
    return await api.put(this.resource + url, payload);
  }

  async delete<T>(url: string, config: AxiosRequestConfig = {}): Promise<T> {
    return await api.delete(this.resource + url, config);
  }

  async patch<T>(url: string, payload: unknown = {}): Promise<T> {
    return await api.patch(this.resource + url, payload);
  }
}

export default ApiService;
